module.exports = __webpack_public_path__ + "img/12.eb4e55f4.jpg";